<script setup lang="ts">
import { onMounted, nextTick } from "vue";

useSeoMeta({
  title: "Daily Motorbike & Scooter Rental in Bali | Bali Bikes Island",
  ogTitle: "Daily Motorbike & Scooter Rental in Bali | Bali Bikes Island",
  description:
    "Rent a scooter or motorbike in Bali for your day-to-day adventures. Bali Bikes Island offers easy, daily rentals with free delivery and well-maintained bikes.",
  ogDescription:
    "Rent a scooter or motorbike in Bali for your day-to-day adventures. Bali Bikes Island offers easy, daily rentals with free delivery and well-maintained bikes.",
  ogImage: "/assets/logo-bali-bikes-main.png",
});

useHead({
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "Bali Bikes Island - Rent Scooter in Bali",
        url: "https://balibikesisland.com/",
        description:
          "Explore Bali with ease by renting a scooter or motorbike from Bali Bikes Island. Affordable prices, easy booking, and free delivery.",
        publisher: {
          "@type": "Organization",
          name: "Bali Bikes Island",
          logo: {
            "@type": "ImageObject",
            url: "https://balibikesisland.com/assets/logo-bali-bikes-main.png",
          },
        },
      }),
    },
  ],
});

onMounted(() => {
  if (useRoute().query?.promo_code) {
    const promoCode: any = useRoute().query?.promo_code || "";
    localStorage.setItem("mitra-promo-code", promoCode);
  }
  const hash = window.location.hash;
  if (hash) {
    nextTick(() => {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          const targetY =
            element.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: targetY, behavior: "smooth" });
        }
      }, 300);
    });
  }
});

definePageMeta({
  delayHydration: "init",
});
</script>

<template>
  <div class="mt-[80px]">
    <DelayHydration>
      <LandingHeader />
      <div class="hidden sm:block">
        <AdsForm />
      </div>
      <div class="relative container mx-auto">
        <div id="bike-collection" class="my-12">
          <Services title="Explore Our Vehicles" />
          <LandingCollection />
        </div>
      </div>
      <LandingTestimonial />
      <LandingPromo isSquare />
      <LandingBlog />
    </DelayHydration>
  </div>
</template>
